// overload component options with a mixin that reports when it is mounted.
// this is transmited all the way up to Saffron.vue, which injects this state to everyone
function assignMountMixin(target) {
  if (!target.mixins) {
    target.mixins = [];
  }

  target.mixins.push({
    emits: ["page-component-mounted"],
    mounted() {
      this.$emit("page-component-mounted", {});
    },
  });

  return true;
}

/**
 * Assign meta configuration from the component options, to the component data.
 * This allows nicer api, so that meta config is not nested inside data, but as a separate entry
 * on the component options
 *
 * @param router
 * @returns {{handler: handler, routerMethod: string}}
 */
export default (router) => {
  return {
    routerMethod: "beforeResolve",
    handler: async (to) => {
      try {
        to.matched.forEach((match) => {
          if (match?.components?.default) {
            assignMountMixin(match.components.default);
          }
        });
      } catch (e) {
        console.log("error");
      }
    },
  };
};
